/**
 * Transform a string into a "handleized" format.
 * @param {string} inputString - The string to handleize.
 * @returns {string} - The handleized string.
 */
export const handleize = (inputString) =>
  inputString
    .toLowerCase()
    .trim()
    /* eslint-disable no-useless-escape */
    .replace(/\s+/g, '-')
    .replace(/[^\w\-]+/g, '')
    .replace(/\-\-+/g, '-');

export const toCamelCase = (str) =>
  str
    .replace(/-/g, ' ')
    .toLowerCase()
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (ltr, idx) => (idx === 0 ? ltr.toLowerCase() : ltr.toUpperCase()))
    .replace(/\s+/g, '');
